module.exports = __webpack_public_path__ + "img/shiba-body-level4.6dd96928.png";